import React, { useState, useEffect } from 'react'
import { NavLink, useHistory } from 'react-router-dom'
import Logo from '../../Images/Logo.webp'
import './RegisterRetailer.css'
import {
  Button,
  CircularProgress,
  Typography,
  Link,
  FormControlLabel,
  Checkbox,
  Snackbar,
} from '@material-ui/core'
import { loginSave } from '../../DataStore/Slices/userSlice'
import { Alert } from '@material-ui/lab'
import classNames from 'classnames'
import { useForm } from 'react-hook-form'
import axios from 'axios'
import server from '../../Backend/axios'
import { checkIsUserExistsOrNot, signup, signupWithGoogle } from '../../Backend/firebase/auth'
import db, { auth, googleProvider } from '../../Backend/firebase/firebase';
import { useSelector } from 'react-redux'
import {
  selectPurchasePlan,
  removePurchasePlan,
} from '../../DataStore/Slices/purchaseSlice'
import { useDispatch } from 'react-redux'
import LoginRetailer from './LoginRetailer'
import Popup from '../Popup'
import CheckIsEmailVerified from '../../DataStore/Hooks/CheckIsEmailVerified'
import {
  ContentState,
  convertToRaw,
  EditorState,
  convertFromHTML,
} from 'draft-js'
import { Editor } from 'react-draft-wysiwyg'
import { Helmet } from 'react-helmet'

function Copyright() {
  return (
    <Typography variant="body2" color="textSecondary" align="center">
      {'Copyright © '}
      <Link color="inherit" href="https://kaipsoolretail.web.app/" target="_blank">
        Kaipsool Pharmatech
      </Link>{' '}
      {new Date().getFullYear()}
      {'.'}
    </Typography>
  )
}

export { Copyright }

const RegisterRetailer = () => {
  const history = useHistory()
  const [detactCountry, setDetactCountry] = useState({
    countryName: '',
    countryCode: '',
  })
  const { register, handleSubmit, errors, setValue } = useForm()
  const [isLoading, setIsLoading] = useState(false)
  const purchasePlan = useSelector(selectPurchasePlan)
  const [openPopup, setOpenPopup] = useState(false)
  const dispatch = useDispatch()
  const [verifyCaptcha, setVerifyCaptcha] = useState(false)
  const [openNotify, setOpenNotify] = React.useState(false)
  const [notificationMessage, setNotificationMessage] = useState('')
  const isEmailVerified = CheckIsEmailVerified()
  const [ProductDescription, setProductDescription] = useState(() =>
    EditorState.createEmpty(),
  )
  const [homeDelivery, setHomeDelivery] = useState('Select Option')
  const [areaCovers, setAreaCovers] = useState('Select Option')

  const handleOpenNotification = () => {
    setOpenNotify(true)
  }

  const handleCloseNotification = (event, reason) => {
    if (reason === 'clickaway') {
      return
    }

    setOpenNotify(false)
  }

  const handleCaptchaOnLoad = () => {
    console.log('Captcha load successfully.')
  }

  const handleCaptchaVerification = (response) => {
    if (response) {
      setVerifyCaptcha(true)
    } else {
      setVerifyCaptcha(false)
    }
  }

  const onSubmit = async (data) => {
    // if (verifyCaptcha) {
    if (data.password === data.confirmPassword) {
      var checkIsUserExists = await checkIsUserExistsOrNot(data.email)
      console.log('checkIsUserExistsOrNot checkIsUserExists', checkIsUserExists)
      if (checkIsUserExists.length <= 0) {
        let user
        try {
          setIsLoading(true)
          data.country = detactCountry.countryName
          if (data != null) {
            let createDataForFirebase = {
              storeName: data.businessName,
              fullName: '',
              email: data.email,
              password: data.password,
              roleName: data.roleName,
              storeWebsite: '',
              storeAddress: '',
              storeCity: '',
              zipcode: '',
              gstNo: '',
              drugLicense: '',
              nameTitle: '',
              name: '',
              homeDelivery: homeDelivery,
              areaCovers: homeDelivery == 'No' ? 'Select Option' : areaCovers,
              remarks: '',
              phoneNumber: '',
              retailerImage: null,
              country: 'India',
              isPlanActivated: true,
            }
            user = await signup(createDataForFirebase)
            if (user != null) {
              setIsLoading(false)
              history.push('/activity/dashboard')
            } else {
              setNotificationMessage(
                'Something went wrong, Please try again later!!',
              )
              handleOpenNotification()
            }
          } else setIsLoading(false)
        } catch (error) {
          console.error(error)
        }
      } else {
        setNotificationMessage(
          'User with this email address is already exists, please try again with another email!!',
        )
        handleOpenNotification()
      }
    } else {
      setNotificationMessage('Passwords do NOT match!')
      handleOpenNotification()
    }
    // } else {
    //     setNotificationMessage('Please verify the captcha first!');
    //     handleOpenNotification();
    // }
  }

  useEffect(() => {
    const getGeoInfo = () => {
      axios
        .get('https://ipapi.co/json/')
        .then((response) => {
          let data = response.data
          setDetactCountry({
            countryName: data.country_name,
            countryCode: data.country_calling_code,
          })
          setValue('country', data.country_name)
        })
        .catch((error) => {
          console.log(error)
        })
    }

    getGeoInfo()
  }, [])

  const onEditorStateChange = (editorState) => {
    setProductDescription(editorState)
  }

  const handleOnTapGoogle = async () => {
    var message = '';
    let firebaseUser = null;
    await auth.signInWithPopup(googleProvider)
      .then(async ({ user }) => {
        firebaseUser = user;
      })
      .catch(error => message = error.message);

    console.log("message", message)
    const rolessRef = db.collection("Users").doc(firebaseUser.uid);
    const doc = await rolessRef.get();
    if (!doc.exists) {
      let user;
      let createDataForFirebase = {
        uid: firebaseUser.uid,
        storeName: firebaseUser?.displayName,
        fullName: firebaseUser?.displayName,
        email: firebaseUser?.email,
        provider: firebaseUser?.providerData[0]?.providerId,
        password: '',
        roleName: 'Retailer',
        storeWebsite: '',
        storeAddress: '',
        storeCity: '',
        zipcode: '',
        gstNo: '',
        drugLicense: '',
        nameTitle: '',
        name: '',
        homeDelivery: homeDelivery,
        areaCovers: homeDelivery == 'No' ? 'Select Option' : areaCovers,
        remarks: '',
        phoneNumber: '',
        retailerImage: null,
        country: 'India',
        isPlanActivated: true,
      }
      user = await signupWithGoogle(createDataForFirebase)
      if (user != null) {
        setIsLoading(false)
        var userData = {
          name: firebaseUser.displayName,
          email: firebaseUser.email,
          uid: firebaseUser.uid,
          userRole: 'Retailer',
          provider: firebaseUser?.providerData[0]?.providerId,
          storeName: '',
          storeAddress: '',
          storeCity: '',
          zipcode: '',
          city: '',
          nameTitle: '',
          function: '',
          remarks: '',
          phoneNumber: '',
          storeWebsite: '',
          country: '',
          isPlanActivated: true,
        }
        dispatch(
          loginSave({
            user: userData,
          }),
        )
        history.push('/activity/dashboard')
      } else {
        setNotificationMessage(
          'Something went wrong, Please try again later!!',
        )
        handleOpenNotification()
      }
    } else {
      setIsLoading(false)
      console.log('document!', doc.data());
      var roleData = doc.data();
      var userData = {
        name: roleData?.name,
        email: roleData?.email,
        uid: roleData?.uid,
        userRole: roleData?.userRole,
        provider: roleData?.provider,
        storeName: roleData?.name,
        storeAddress: roleData?.storeAddress,
        storeCity: roleData?.storeCity,
        zipcode: roleData?.zipcode,
        city: roleData?.city,
        nameTitle: roleData?.nameTitle ? roleData?.nameTitle : '',
        function: roleData?.function,
        remarks: roleData?.remarks,
        phoneNumber: roleData?.phoneNumber,
        storeWebsite: roleData?.storeWebsite,
        country: roleData?.country,
        isPlanActivated: true,
      }
      dispatch(
        loginSave({
          user: userData,
        }),
      )
      setIsLoading(false)
      history.push('/activity/dashboard')
    }
  };

  return (
    <>
      <div className="container-fluid registerRetailer">
        <Helmet>
          <meta
            name="description"
            content="Please register as retailer to post products who will help you to get best talent..."
          />
          <title>Retailer Registation | Kaipsool Pharmatech</title>
        </Helmet>
        <div className="row">
          <div className="col-lg-10 col-md-10 col-sm-12 mx-auto">
            <div className="row">
              <div className="col-md-12 text-center">
                <NavLink className="" to="/">
                  <img
                    className="img-fluid"
                    src={Logo}
                    alt="Website Logo"
                    width="200px"
                  />
                </NavLink>
              </div>
              <div className="col-md-12">
                <div className="form-block">
                  <header className="login__header">
                    <div className="header__block header__block_signup">
                      <h4 className="header__block_title">Create An Account</h4>
                    </div>
                    <hr className="header__block_sep" />
                  </header>
                  <main className="main">
                    <div className="main__block main__block_signup">
                      <div className="main__block_left">
                        <div className="sign-up">
                          <form
                            className="sign-up__form"
                            onSubmit={handleSubmit(onSubmit)}
                          >
                            <div className="sign-up__block">
                              <label className="sign-up__label" for="roleName">
                                User Type{' '}
                                <span
                                  className="text-danger"
                                  style={{
                                    fontSize: '18px',
                                    fontWeight: '900',
                                    marginLeft: '3px',
                                  }}
                                >
                                  *
                                </span>
                              </label>
                              <select
                                className={classNames(
                                  'sign-up__field',
                                  { 'is-invalid': errors.roleName },
                                )}
                                aria-label="Default select example"
                                name="roleName"
                                ref={register}
                                defaultValue="Select Option"
                              >
                                <option value="Select Option">Select Option</option>
                                <option value="Chemist">Chemist</option>
                                <option value="Wholesaler">Wholesaler</option>
                              </select>
                              <small className="form-text text-danger">
                                {errors.roleName && errors.roleName.message}
                              </small>
                            </div>
                            <div className="sign-up__block">
                              <label className="sign-up__label" for="businessName">
                                Business Name{' '}
                                <span
                                  className="text-danger"
                                  style={{
                                    fontSize: '18px',
                                    fontWeight: '900',
                                    marginLeft: '3px',
                                  }}
                                >
                                  *
                                </span>
                              </label>
                              <input
                                placeholder="e.g Butame Pharma"
                                type="text"
                                className={classNames(
                                  'sign-up__field sign-up__field_email',
                                  { 'is-invalid': errors.businessName },
                                )}
                                name="businessName"
                                autoComplete="off"
                                ref={register({
                                  required: 'Please enter your Business Name!',
                                })}
                              />
                              <small className="form-text text-danger">
                                {errors.businessName && errors.businessName.message}
                              </small>
                            </div>
                            <div className="sign-up__block">
                              <label className="sign-up__label" for="email">
                                Enter your email{' '}
                                <span
                                  className="text-danger"
                                  style={{
                                    fontSize: '18px',
                                    fontWeight: '900',
                                    marginLeft: '3px',
                                  }}
                                >
                                  *
                                </span>
                              </label>
                              <input
                                placeholder="e.g maister909@gmail.com"
                                type="email"
                                className={classNames(
                                  'sign-up__field sign-up__field_email',
                                  { 'is-invalid': errors.email },
                                )}
                                name="email"
                                autoComplete="off"
                                ref={register({
                                  required: 'Please enter your email address!',
                                })}
                              />
                              <small className="form-text text-danger">
                                {errors.email && errors.email.message}
                              </small>
                            </div>
                            <div className="sign-up__block mt-3">
                              <label className="sign-up__label" for="password">
                                Enter your password{' '}
                                <span
                                  className="text-danger"
                                  style={{
                                    fontSize: '18px',
                                    fontWeight: '900',
                                    marginLeft: '3px',
                                  }}
                                >
                                  *
                                </span>
                              </label>
                              <input
                                placeholder="e.g qwerty!123"
                                type="password"
                                className={classNames(
                                  'sign-up__field sign-up__field_username',
                                  { 'is-invalid': errors.password },
                                )}
                                name="password"
                                autoComplete="off"
                                ref={register({
                                  required: 'Please enter your password!',
                                  minLength: {
                                    value: 6,
                                    message:
                                      'Password should be at least 6 characters!',
                                  },
                                  maxLength: {
                                    value: 100,
                                    message:
                                      'Password should be 15 length maximum!',
                                  },
                                })}
                              />
                              <small className="form-text text-danger">
                                {errors.password && errors.password.message}
                              </small>
                            </div>
                            <div className="sign-up__block mt-3">
                              <label className="sign-up__label" for="confirmPassword">
                                Confirm Password{' '}
                                <span
                                  className="text-danger"
                                  style={{
                                    fontSize: '18px',
                                    fontWeight: '900',
                                    marginLeft: '3px',
                                  }}
                                >
                                  *
                                </span>
                              </label>
                              <input
                                placeholder="e.g qwerty!123"
                                type="password"
                                className={classNames(
                                  'sign-up__field sign-up__field_username',
                                  { 'is-invalid': errors.confirmPassword },
                                )}
                                name="confirmPassword"
                                autoComplete="off"
                                ref={register({
                                  required: 'Please enter your Confirm Password!',
                                  minLength: {
                                    value: 6,
                                    message:
                                      'Confirm Password should be at least 6 characters!',
                                  },
                                  maxLength: {
                                    value: 100,
                                    message:
                                      'Confirm Password should be 15 length maximum!',
                                  },
                                })}
                              />
                              <small className="form-text text-danger">
                                {errors.confirmPassword && errors.confirmPassword.message}
                              </small>
                            </div>
                            <div className="sign-up__block mt-4">
                              <Button
                                type="submit"
                                variant="contained"
                                color="primary"
                                size="small"
                                className="login__btn sign-up__submit"
                              >
                                {isLoading ? (
                                  <CircularProgress size={18} />
                                ) : (
                                  'Register'
                                )}
                              </Button>
                            </div>
                          </form>
                        </div>
                        <hr />
                        <p className="content__footer-text center-align">
                            Already have an account?{' '}
                            <a
                              className="content__footer__link"
                              href="/activity/Login"
                              title="Sign up via form"
                              onclick={() => history.push('/activity/Login')}
                            >
                              Login here
                            </a>
                          </p>
                      </div>
                      {/* <span className="main__block_sep"></span>
                      <div className="main__block_right social">
                        <div className="social__btns btns">
                          <button
                            className="btns__signup social__btns_gl"
                            onClick={handleOnTapGoogle}
                          >
                            <span>Register With Google</span>
                          </button><br />
                          <p className="content__footer-text">
                            Already have an account?{' '}
                            <a
                              className="content__footer__link"
                              href="/activity/Login"
                              title="Sign up via form"
                              onclick={() => history.push('/activity/Login')}
                            >
                              Login here
                            </a>
                          </p>
                        </div>
                      </div> */}
                    </div>
                  </main>
                </div>
              </div>
              <div className="col-md-12 mb-4">
                <Copyright />
              </div>
            </div>
          </div>
        </div>
      </div>

      <Popup
        openPopup={openPopup}
        setOpenPopup={setOpenPopup}
        title="Chemist Store Sign In"
      >
        <LoginRetailer isCaptchaVisible={true} />
      </Popup>

      <Snackbar
        open={openNotify}
        autoHideDuration={6000}
        onClose={handleCloseNotification}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <Alert onClose={handleCloseNotification} severity="error">
          {notificationMessage}
        </Alert>
      </Snackbar>
    </>
  )
}

export default RegisterRetailer
